module.exports = __webpack_public_path__ + "static/android-icon-192x192-8a49e433ba9408ed8575034abd26d87e.png";